export const TRACK_ACTION_TYPES = {
	CLICK: 'Click',
	NAVIGATION: 'Navigation',
	PAGE_VIEWED: 'Page Viewed',
	SAVE: 'Save',
	UX_CONFIGURATION: 'UX Configuration',
};

export const PAGES = {
	DASHBOARD: 'Dashboard',
	ITEMS: 'Items',
	PROPOSALS: 'Proposals',
	INVOICES: 'Invoices',
	MOODBOARDS: 'Mood Boards',
	MOODBOARD: 'Mood Board',
	PAYMENTS: 'Payments',
} as const;

export type TPage = (typeof PAGES)[keyof typeof PAGES];
